/** Drop moment: Wednesday, August 12, 2026 — 6:00 PM Central (CDT). */
export const DROP_TARGET_MS = Date.parse('2026-08-12T18:00:00-05:00');

export interface CountdownParts {
	live: boolean;
	days: string;
	hours: string;
	minutes: string;
	seconds: string;
}

export function getCountdownParts(
	nowMs: number,
	targetMs: number = DROP_TARGET_MS,
): CountdownParts {
	const diff = targetMs - nowMs;
	const totalSeconds = Math.max(0, Math.floor(diff / 1000));
	const pad = (n: number) => String(n).padStart(2, '0');

	return {
		live: diff <= 0,
		days: pad(Math.floor(totalSeconds / 86400)),
		hours: pad(Math.floor(totalSeconds / 3600) % 24),
		minutes: pad(Math.floor(totalSeconds / 60) % 60),
		seconds: pad(totalSeconds % 60),
	};
}
